// src/app/state/reducers/try-it.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as TryItActions from '../actions/try-it.actions';
import * as AuthActions from '../actions/auth.actions';
import { TryItState } from '../models/try-it.model';

export const initialState: TryItState = {
  selectedLanguage: 'Bash',
  selectedCodeGenerator: 'shell_curl',
  selectedUrl: 'https://api.example.com/v1',

  // Initialize authentication properties
  apiKeyCredentials: {},
  httpCredentials: { scheme: '', token: '' },
  oauth2Credentials: {},
  openIdCredentials: { idToken: '', refreshToken: '' },
  activeAuthSecurityRequirement: {
    index: 0,
    requirementKey: ''
  },
  tryItHistoryPanelOpen: false // default collapsed
};

export const tryItReducer = createReducer(
  initialState,
  on(TryItActions.setSelectedLanguage, (state, { languageTitle }) => ({
    ...state,
    selectedLanguage: languageTitle,
  })),
  on(TryItActions.setSelectedCodeGenerator, (state, { codeGeneratorCode }) => ({
    ...state,
    selectedCodeGenerator: codeGeneratorCode,
  })),
  on(TryItActions.setSelectedServer, (state, { url }) => ({
    ...state,
    selectedUrl: url,
  })),
  on(TryItActions.setApiKeyCredential, (state, { name, value }) => ({
    ...state,
    apiKeyCredentials: {
      ...state.apiKeyCredentials,
      [name]: value,
    },
  })),
  on(TryItActions.setHttpCredentials, (state, { scheme, token }) => ({
    ...state,
    httpCredentials: { scheme, token },
  })),
  on(TryItActions.setOAuth2Credentials, (state, { flowName, accessToken, refreshToken, scopes }) => ({
    ...state,
    oauth2Credentials: {
      ...state.oauth2Credentials,
      [flowName]: {
        accessToken,
        refreshToken,
        scopes,
      },
    },
  })),
  on(TryItActions.setOpenIdCredentials, (state, { idToken, refreshToken }) => ({
    ...state,
    openIdCredentials: { idToken, refreshToken },
  })),
  on(TryItActions.setActiveAuthSecurityRequirement, (state, { index, requirementKey }) => ({
    ...state,
    activeAuthSecurityRequirement: { index, requirementKey }
  })),
  on(TryItActions.setTryItHistoryPanelOpen, (state, { open }) => ({
    ...state,
    tryItHistoryPanelOpen: open
  })),
  
  // Reset authentication-related state on logout or clearUserData
  on(AuthActions.logout, AuthActions.clearUserData, (state) => ({
    ...state,
    apiKeyCredentials: initialState.apiKeyCredentials,
    httpCredentials: initialState.httpCredentials,
    oauth2Credentials: initialState.oauth2Credentials,
    openIdCredentials: initialState.openIdCredentials
  }))
);
